<script setup lang="ts">
import type { ISubwayStationsListProps } from '@/shared/ui/SubwayStationsList/model/types/subwayStationList';

withDefaults(defineProps<ISubwayStationsListProps>(), {
  stations: () => [],
});

const isMobile: boolean = useIsMobile();

const getDistance = (distance: number): string => {
  if (distance < 1000) return `${distance || 10} м`;
  return `${distance ? (distance / 1000).toFixed(2) : '0'} км`;
};
</script>

<template>
  <ul :class="['subway-stations-list', { _mobile: isMobile }]">
    <li v-for="station in stations" :key="station.id" class="subway-stations-list__item">
      <span
        class="subway-stations-list__item-color"
        :style="{ backgroundColor: `${station.color}` }"
      ></span>
      <span class="subway-stations-list__item-name">{{ station.name }}</span>
      <strong>{{ getDistance(station.distance) }}</strong>
    </li>
  </ul>
</template>

<style lang="less">
.subway-stations-list {
  &__item {
    font-size: @size-x3;
    line-height: @size-x4;
    color: @color-dove-gray;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &:not(:last-child) {
      margin-bottom: 3px;
    }
  }

  &__item-color {
    display: inline-block;
    width: @size-x2;
    height: @size-x2;
    border-radius: 100%;
  }

  &__item-name {
    font-weight: 500;
    margin: 0 5px;
  }

  &._mobile &__item {
    font-size: @size-x3;
    line-height: @size-x4;
  }
}
</style>
